import { useEffect, useState } from 'react';
import useWindowSize from '@hooks/useWindowSize';
import { useRouter } from 'next/router';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import styled from '@emotion/styled';
import useOfflineGoalData from '@api/hooks/enquiry/useOfflineGoalData';
import useCounsellorName from '@api/hooks/enquiry/useCounsellorName';
import StaticInfo from '../CitySelection/StaticInfo';
import StaticInfoImage from './StaticInfoImage';
import StaticInfoOfferings from './StaticInfoOfferings';
import EnquiryForm from './EnquiryForm';
import EnquiryThankyou from './EnquiryThankyou';
import { EnquiryPageWrapper, TabletWrapper, HR, Heading } from './styles';

const LoaderWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const EnquiryPage = ({ cmsData }) => {
  const router = useRouter();
  const {
    form_type: formType,
    counsellor,
    counsellor_email: counsellorEmail
  } = router.query;

  const { offlineGoals, isGoalDataLoading } = useOfflineGoalData();
  const { counsellorName, isCounsellorNameLoading } =
    useCounsellorName(counsellor);

  const isLoading =
    isGoalDataLoading || (counsellor && isCounsellorNameLoading);

  const { isTablet, isMobile } = useWindowSize();
  const [thankyouPage, showThankyouPage] = useState(false);
  const { selectionPage: { heading } = {} } = cmsData || {};
  const goalsData = [];
  offlineGoals?.goal_uids?.forEach((uid, index) =>
    goalsData.push({
      id: index + 1,
      value: uid,
      label: offlineGoals.goal_names[index]
    })
  );

  useEffect(() => {
    if (!thankyouPage || formType === 'content_sales') return;

    const timer = setTimeout(() => {
      router.push('/all-centre');
    }, 3000);

    return () => clearTimeout(timer);
  }, [thankyouPage, formType, router]);

  if (isLoading)
    return (
      <LoaderWrapper>
        <CircularLoader />
      </LoaderWrapper>
    );
  if (thankyouPage) return <EnquiryThankyou />;
  return (
    <EnquiryPageWrapper>
      {!isMobile && !isTablet && <StaticInfo cmsData={cmsData} />}
      {isMobile && <StaticInfoImage cmsData={cmsData} />}
      {!isMobile && isTablet && (
        <>
          <Heading>{heading}</Heading>
          <TabletWrapper>
            <StaticInfoImage cmsData={cmsData} />
            <StaticInfoOfferings cmsData={cmsData} />
          </TabletWrapper>
          <HR />
        </>
      )}
      <EnquiryForm
        cmsData={cmsData}
        offlineGoals={goalsData}
        counsellorName={counsellorName}
        counsellorEmail={counsellorEmail}
        formType={formType}
        showThankyouPage={showThankyouPage}
      />
      {isMobile && <StaticInfoOfferings cmsData={cmsData} />}
    </EnquiryPageWrapper>
  );
};

export default EnquiryPage;
